const Config = {
    image_dir: "./assets/img/",
    json_file: "./assets/data/data.json",
};

export default Config;
